export default {
  "content": "<path fill=\"#22264C\" d=\"M2.65 3.915L2.788 9H0V0h3.905l1.608 4.843h.062L6.97 0H11v9H8.1l.087-5.06-.075-.012L6.454 9h-2.11L2.713 3.915z\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "width": "12",
    "height": "10",
    "viewBox": "0 0 12 10",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};